import { __assign, __rest } from "tslib";
import clsx from 'clsx';
import * as React from 'react';
import { Alert as MuiAlert } from '@material-ui/lab';
import { useTheme } from '@material-ui/core';
import { IconButton } from '../IconButton';
import { Close } from '../../internal/icons/medium';
import { useStyles } from './Banner.styles';
import { BbThemeProvider } from '../BbThemeProvider';
export var Banner = function (props) {
    var children = props.children, className = props.className, icon = props.icon, severity = props.severity, others = __rest(props, ["children", "className", "icon", "severity"]);
    var styles = useStyles(props);
    var isErrorOrWarning = severity === 'error' || severity === 'warning';
    var _a = useTheme(), direction = _a.direction, palette = _a.palette;
    var themeProviderProps = {
        theme: severity === 'warning' ? 'light' : palette.type,
        isRtl: direction === 'rtl',
    };
    var getAction = function () {
        if ('actions' in props) {
            return (React.createElement(React.Fragment, null, props.actions.map(function (action) {
                return React.cloneElement(action, {
                    className: clsx(action.props && action.props.className, styles.action),
                });
            })));
        }
        if ('onClose' in props && 'closeText' in props) {
            return (React.createElement(IconButton, { className: styles.dismissAction, "aria-label": props.closeText, title: props.closeText, onClick: props.onClose },
                React.createElement(Close, null)));
        }
        return null;
    };
    var action = getAction();
    return (React.createElement(MuiAlert, __assign({}, others, { className: clsx(className, styles.root), 
        /* Reset the role, so we can properly place it on the inner body */
        role: "presentation", action: action ? React.createElement(BbThemeProvider, __assign({}, themeProviderProps), action) : undefined, 
        /* Ensure that we always specify an icon, to override Material-UI's default icon mapping */
        icon: icon || false, severity: severity || 'info' }),
        React.createElement(BbThemeProvider, __assign({}, themeProviderProps),
            React.createElement("div", { className: styles.message, tabIndex: -1, role: isErrorOrWarning ? 'alert' : 'status', "aria-live": isErrorOrWarning ? 'assertive' : 'polite' }, children))));
};
//# sourceMappingURL=Banner.js.map